import React from 'react'
import Helmet from 'react-helmet'
import { CONFIG } from '../../config'

export interface ISEOProps {
  description?: string
  lang?: string
  meta?: Array<object>
  keywords?: Array<string>
  title?: string
  image?: string
  pathname?: string
}

const SEO = ({
  description = '',
  lang = 'en',
  meta = [],
  keywords = [],
  title,
  image,
  pathname,
}: ISEOProps) => {
  const metaDescription = description || CONFIG.WEBSITE_DESCRIPTION
  const siteTitle = CONFIG.WEBSITE_TITLE
  const siteAuthor = CONFIG.WEBSITE_AUTHOR
  const titleTemplate = siteTitle === title ? title : `%s | ${siteTitle}`

  const baseUrl = CONFIG.WEBSITE_SITEURL
  const canonicalUrl = pathname ? `${baseUrl}${pathname}` : undefined
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={titleTemplate}
      link={[
        {
          href: `${baseUrl}/`,
          rel: 'home',
        },
        ...(canonicalUrl
          ? [
              {
                href: canonicalUrl,
                rel: 'canonical',
              },
              {
                href: canonicalUrl,
                hrefLang: 'en-AU',
                rel: 'alternate',
              },
            ]
          : []),
      ]}
      // @ts-ignore
      meta={[
        {
          name: 'description',
          content: metaDescription,
        },
        {
          property: 'og:title',
          content: title,
        },
        {
          property: 'og:description',
          content: metaDescription,
        },
        image && {
          property: 'og:image',
          content: image,
        },
        canonicalUrl && {
          property: 'og:url',
          content: canonicalUrl,
        },
        CONFIG.FACEBOOK_APP_ID && {
          property: 'fb:app_id',
          content: CONFIG.FACEBOOK_APP_ID,
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          name: 'twitter:card',
          content: 'summary',
        },
        {
          name: 'twitter:creator',
          content: siteAuthor,
        },
        {
          name: 'twitter:title',
          content: title,
        },
        {
          name: 'twitter:description',
          content: metaDescription,
        },
      ]
        .filter((a) => a)
        .concat(
          keywords.length > 0
            ? {
                name: 'keywords',
                content: keywords.join(', '),
              }
            : []
        )
        .concat(meta)}
    ></Helmet>
  )
}

export { SEO }
